<template>
  <v-row no-gutters>
    <v-btn class="mx-3" icon @click="postFacebook()">
      <img id="sns-fb-btn" src="/kawabou/img/sns_icons/facebook.png" />
    </v-btn>
    <v-btn class="mx-3" icon @click="postTwitter()">
      <div v-if="dispOverlay" class="com-modal com-modal-overlay">
        <v-overlay data-html2canvas-ignore="true">
          <v-progress-circular
            indeterminate
            :size="60"
            :width="8"
          ></v-progress-circular>
        </v-overlay>
      </div>
      <img id="sns-tw-btn" src="/kawabou/img/sns_icons/twitter.png" />
    </v-btn>
    <v-btn class="mx-3" icon @click="textLine()">
      <img id="sns-line-btn" src="/kawabou/img/sns_icons/line.png" />
    </v-btn>
  </v-row>
</template>

<script>
import mixin from "./../../../lib/mixin.js";
import PageLog from "./../../../lib/pageLog.js";
export default {
  name: "tm-detail-sns",
  mixins: [mixin],
  data() {
    return {
      itmkndCd: Number(this.$route.query["itmkndCd"]),
      dispOverlay: false,
    };
  },
  props: {
    dispContentsSwitch: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    if (!this.$store.state.app.isCurrent) {
      this.$store.commit("Telemeter/setMovieEndTime", this.$store.state.app.appTime);
    }
    this.replaceTmQuery();
  },
  computed: {
    /** 選択される情報取得 */
    selectedTm: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    selectedSw: {
      get() {
        return this.$store.state.Swin.selectedSw;
      },
    },
    postText: {
      get() {
        switch (this.itmkndCd) {
          case 1:
            return {
              view: "雨量観測所詳細画面",
              obsNm: this.selectedTm.tmRainDetailInfo.obsNm,
              rvrNm: this.selectedTm.tmRainDetailInfo.rvrNm,
              rsysNm: this.selectedTm.tmRainDetailInfo.rsysNm,
            };
          case 2:
            return {
              view: "流域平均観測所詳細画面",
              obsNm: this.selectedTm.tmBsnDetailInfo.obsNm,
              rvrNm: this.selectedTm.tmBsnDetailInfo.rvrNm,
              rsysNm: this.selectedTm.tmBsnDetailInfo.rsysNm,
            };
          case 3:
            return {
              view: "積雪観測所詳細画面",
              obsNm: this.selectedTm.tmSnwDetailInfo.obsNm,
              rvrNm: this.selectedTm.tmSnwDetailInfo.rvrNm,
              rsysNm: this.selectedTm.tmSnwDetailInfo.rsysNm,
            };
          case 4:
            return {
              view: "水位観測所詳細画面",
              obsNm: this.selectedTm.tmStgDetailInfo.obsNm,
              rvrNm: this.selectedTm.tmStgDetailInfo.rvrNm,
              rsysNm: this.selectedTm.tmStgDetailInfo.rsysNm,
            };
          case 6:
            return {
              view: "水質観測所詳細画面",
              obsNm: this.selectedTm.tmQwtrDetailInfo.obsNm,
              rvrNm: this.selectedTm.tmQwtrDetailInfo.rvrNm,
              rsysNm: this.selectedTm.tmQwtrDetailInfo.rsysNm,
            };
          case 7:
            return {
              view: "ダム観測所詳細画面",
              obsNm: this.selectedTm.tmDamDetailInfo.obsNm,
              rvrNm: this.selectedTm.tmDamDetailInfo.rvrNm,
              rsysNm: this.selectedTm.tmDamDetailInfo.rsysNm,
            };
          case 12:
            return {
              view: "海岸観測所詳細画面",
              obsNm: this.selectedTm.tmCoastDetailInfo.obsNm,
              rvrNm: this.selectedTm.tmCoastDetailInfo.rvrNm,
              rsysNm: this.selectedTm.tmCoastDetailInfo.rsysNm,
            };
          case 20:
            return {
              view: "レーダ流域観測所詳細画面",
              obsNm: this.selectedTm.tmRdBsnDetailInfo.obsNm,
              rvrNm: this.selectedTm.tmRdBsnDetailInfo.rvrNm,
              rsysNm: this.selectedTm.tmRdBsnDetailInfo.rsysNm,
            };
          case 300:
            return {
              view: "水位計詳細画面",
              obsNm: this.selectedSw.mtSwobs.obsInfo.swobsNm,
              rvrNm: this.selectedSw.mtSwobs.obsInfo.swrvrNm,
              rsysNm: this.selectedSw.mtSwobs.obsInfo.swrsysNm,
            };
          default:
            return null;
        }
      },
    },
    postCamera: {
      get() {
        return this.$store.state.sns.postCamera;
      },
    },
    printCurrentPicture: {
      get() {
        return this.$store.state.sns.printCurrentPicture;
      },
    },
    printNormallyPicture: {
      get() {
        return this.$store.state.sns.printNormallyPicture;
      },
    },
    obsFcd: {
      get() {
        if (this.itmkndCd === 100 || this.itmkndCd === 200) {
          return "-";
        } else if (this.itmkndCd === 300) {
          return this.$store.state.Swin.selectedSwParam.swobsCd;
        } else {
          return (
            ("0000" + this.$store.state.Telemeter.selectedTmParam.ofcCd).slice(
              -5
            ) +
            ("00" + this.$store.state.Telemeter.selectedTmParam.itmkndCd).slice(
              -3
            ) +
            ("0000" + this.$store.state.Telemeter.selectedTmParam.obsCd).slice(
              -5
            )
          );
        }
      },
    },
    camCd: {
      get() {
        if (this.itmkndCd === 100 || this.itmkndCd === 200) {
          return this.$store.state.Telemeter.selectedTmParam.scamId;
        } else {
          return "-";
        }
      },
    },
    camSb: {
      get() {
        if (this.itmkndCd === 100) {
          return "cctv";
        } else if (this.itmkndCd === 200) {
          return "scam";
        } else {
          return "-";
        }
      },
    },
    lineText: {
      get() {
        return this.$store.state.sns.lineText;
      },
    },
  },
  imageTimeOut: {
    get() {
      return this.$store.state.app.config.snsConfig.twitter.imageTimeOut;
    },
  },
  methods: {
    /** FaceBook投稿 */
    postFacebook() {
      this.$log.debug("[TmDetailSns] postFacebook()");
      // アクセスログ出力
      PageLog.log({
        page_log: "mob_sns",
        obs_cd: this.obsFcd,
        cam_cd: this.camCd,
        cam_sb: this.camSb,
        device_sb: "pc",
        sns: "fb",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.$store.dispatch("sns/postFacebook", { url: location.href });
    },
    /** LINE投稿テキスト生成 */
    textLine() {
      this.$log.debug("[TmDetailSns] textLine()");
      this.$log.debug(
        "[TmDetailSns] postType: " + this.getPostType(this.itmkndCd)
      );

      if (this.getPostType(this.itmkndCd) === "obs") {
        this.$store.dispatch("sns/textLineObs", {
          view: this.postText.view,
          obsNm: this.postText.obsNm,
          rvrNm: this.postText.rvrNm,
          rsysNm: this.postText.rsysNm,
        });
      } else if (
        this.getPostType(this.itmkndCd) === "scam" ||
        this.getPostType(this.itmkndCd) === "cctv"
      ) {
        this.$store.dispatch("sns/textLineCam", {
          view: this.postText.view,
          camNm: this.postText.obsNm,
          rvrNm: this.postText.rvrNm,
          rsysNm: this.postText.rsysNm,
          camUrl: this.getCamUrl(),
          mode: "pc",
        });
      }
      this.$store.commit("sns/setType", this.getPostType(this.itmkndCd));
    },
    /** LINE投稿 */
    postLine() {
      // アクセスログ出力
      PageLog.log({
        page_log: "mob_sns",
        obs_cd: this.obsFcd,
        cam_cd: this.camCd,
        cam_sb: this.camSb,
        device_sb: "pc",
        sns: "ln",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });

      this.$store.dispatch("sns/postLine", {
        lat: this.$route.query["clat"],
        lon: this.$route.query["clon"],
        mode: "pc",
      });
    },
    /** Twitter投稿 */
    async postTwitter() {
      this.$log.debug("[TmDetailSns] postTwitter()");
      this.dispOverlay = true;
      // アクセスログ出力
      PageLog.log({
        page_log: "mob_sns",
        obs_cd: this.obsFcd,
        cam_cd: this.camCd,
        cam_sb: this.camSb,
        device_sb: "pc",
        sns: "tw",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      if (
        this.getPostType(this.itmkndCd) === "obs" ||
        this.getPostType(this.itmkndCd) === "scam"
      ) {
        this.getTextObs();
        await this.getCapture();
      } else if (this.getPostType(this.itmkndCd) === "cctv") {
        this.getTextCam();
        await this.getCaptureStageDetail();
      }
      this.getRequestToken();
      this.dispOverlay = false; 
    },
    /** Twitterリクエストトークンを取得 */
    getRequestToken() {
      this.$log.debug("[TmDetailSns] getRequestToken()");
      const subWin = window.open("", "_blank");
      this.$store.dispatch("sns/getRequestToken", {subWin});
    },
    /** 投稿カメラURLを取得 */
    getCamUrl() {
      this.$log.debug("[TmDetailSns] getCamUrl()");
      this.$log.debug("postCamera: " + this.postCamera);
      if (this.postCamera == "live") {
        return this.printCurrentPicture;
      } else if (this.postCamera == "normal") {
        return this.printNormallyPicture;
      }
    },
    /** Twitter投稿テキストを取得 */
    getTextObs() {
      this.$log.debug("[TmDetailSns] getTextObs()");
      this.$store.dispatch("sns/getTextObs", {
        url: location.href,
        view: this.postText.view,
        obsNm: this.postText.obsNm,
        rvrNm: this.postText.rvrNm,
        rsysNm: this.postText.rsysNm,
      });
    },
    /** Twitter投稿テキストを取得 */
    getTextCam() {
      this.$log.debug("[TmDetailSns] getTextCam()");
      this.$store.dispatch("sns/getTextCam", {
        url: location.href,
        view: this.postText.view,
        camNm: this.postText.obsNm,
        rvrNm: this.postText.rvrNm,
        rsysNm: this.postText.rsysNm,
        camUrl: this.getCamUrl(),
      });
    },
    /** Twitter投稿画像を取得 */
    async getCapture() {
      this.$log.debug("[TmDetailSns] getCapture()");
      await this.$store.dispatch("sns/getCapture", { type: "detail", imageTimeOut: this.imageTimeOut });
    },
    /** Twitter投稿画像を取得(カメラあり) */
    async getCaptureStageDetail() {
      this.$log.debug("[TmDetailSns] getCaptureStageDetail()");
      await this.$store.dispatch("sns/getCaptureStageDetail", { imageTimeOut: this.imageTimeOut });
    },
    getPostType(itmkndCd) {
      this.$log.debug("[TmDetailSns] getPostType(" + itmkndCd + ")");
      if (
        this.itmkndCd != 4 &&
        this.itmkndCd != 300 &&
        this.itmkndCd != 100 &&
        this.itmkndCd != 200
      ) {
        return "obs";
      } else if (
        (this.itmkndCd == 4 || this.itmkndCd == 300) &&
        this.dispContentsSwitch
      ) {
        return "obs";
      } else if (
        (this.itmkndCd == 4 || this.itmkndCd == 300) &&
        !this.dispContentsSwitch
      ) {
        if (
          this.postCamera == "live" &&
          this.printCurrentPicture.startsWith("https://cam.river.go.jp/")
        ) {
          return "scam";
        } else if (
          this.postCamera == "normal" &&
          this.printNormallyPicture.startsWith("https://cam.river.go.jp/")
        ) {
          return "scam";
        } else {
          return "cctv";
        }
      } else if (this.itmkndCd == 200) {
        return "scam";
      } else if (this.itmkndCd == 100) {
        return "cctv";
      } else {
        return null;
      }
    },
  },
  watch: {
    lineText() {
      if (this.lineText != null) {
        this.postLine();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#sns-fb-btn {
  height: 25px;
  width: 25px;
  margin-left: 10px;
  margin-right: 10px;
}
#sns-tw-btn {
  height: 25px;
  width: 25px;
  margin-left: 10px;
  margin-right: 10px;
}
#sns-line-btn {
  height: 25px;
  width: 25px;
  margin-left: 10px;
  margin-right: 10px;
}
</style>
